<template>
  <ui-modal-layout :title="tr('Advantage+ Creative Features')">
    <div class="flex flex-col gap-2.5">
      <label
        v-for="(item, key) in apCreativeFeatures"
        :key="'ap-creative-feature--' + key"
        v-tooltip.right="tr(item.info)"
        :class="[ 'flex w-fit items-center gap-2 text-sm text-foreground', disabled ? 'cursor-not-allowed' : 'cursor-pointer' ]"
      >
        <ui-checkbox
          :model-value="!!modelValue[item.machine_name]"
          :disabled="disabled"
          @update:model-value="(value) => setFeature(item.machine_name, value)"
        />
        {{ tr(item.label) }}
      </label>
    </div>

    <template #footer>
      <ui-button @click="() => $emit('close')">
        {{ tr('Apply and Close') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>

/** Advantage+ creative feature toggles; edits the passed settings object in place. */
export default {
  name: 'MetaApCreativeFeaturesModal',
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  emits: [ 'update:modelValue', 'close' ],
  computed: {
    apCreativeFeatures() {
      return this.$store.getters['app/facebookApCreativeFeatures'];
    },
  },
  methods: {
    setFeature(feature, value) {
      this.$emit('update:modelValue', { ...this.modelValue, [feature]: value });
    },
  },
};
</script>
